import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { TimesheetWidgets } from "Types";

import { Card, CardSubtitle, CardsWrapper, CardTitle, Wrapper } from "./styles";

type TimesheetHeaderProps = {
  timesheetWidgets?: TimesheetWidgets;
};

export const TimesheetHeader: React.FC<TimesheetHeaderProps> = (props) => {
  const { timesheetWidgets } = props;
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      <CardsWrapper>
        <Card color={colors.success50}>
          <CardTitle color={colors.success700}>{timesheetWidgets?.workHours || "0h 00m"}</CardTitle>
          <CardSubtitle color={colors.success700}>{translate("workHours")}</CardSubtitle>
        </Card>
        <Card color={colors.warning50}>
          <CardTitle color={colors.warning700}>
            {timesheetWidgets?.breakHours || "0h 00m"}
          </CardTitle>
          <CardSubtitle color={colors.warning700}>{translate("breakHours")}</CardSubtitle>
        </Card>
      </CardsWrapper>
      <div>
        <Card color={colors.gray50}>
          <CardTitle color={colors.gray800}>{timesheetWidgets?.mostCommonTask || "-"}</CardTitle>
          <CardSubtitle color={colors.gray800}>{translate("mostCommonTask")}</CardSubtitle>
        </Card>
      </div>
    </Wrapper>
  );
};
